import { LongRunningTaskManager } from './long.running.task.manager';

export { LongRunningTaskManager } from './long.running.task.manager';
export { LongRunningTaskManagerService } from './long.running.task.manager.service';
export { LongRunningTaskManagerState, getDisplayStatus } from './long.running.task.manager.state';
export type {
	LongRunningExport,
	LongRunningTask,
	LongRunningTaskDisplayStatus,
} from './long.running.task.manager.state';

/**
 * Lazy singleton to avoid circular dependency with Services.
 * LongRunningTaskManager imports Services, so it cannot be instantiated
 * inside the ServiceRegistry constructor.
 */
let _instance: LongRunningTaskManager | null = null;

export function getLongRunningTaskManager(): LongRunningTaskManager {
	if (_instance == null) {
		_instance = new LongRunningTaskManager();
	}
	return _instance;
}
